import { ofType } from "redux-observable";
import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import S from "sanctuary";

import {
  REQUEST_PERISCOPE_DASHBOARD,
  getPeriscopeDashboardSucceeded,
  getPeriscopeDashboardFailed,
} from "./PeriscopeDashboard.state";

import {
  getCurrentUserAgencies,
  getCurrentUserClient,
} from "@/components/currentUser/CurrentUser.state";
import { getAuthToken } from "@/util/session";
import { getPeriscopeDashboard } from "@/APIClient";
import { requestEpic } from "@/APIClient/observable.util";

const requestPeriscopeDashboardEpic = (action$, state$) =>
  action$.pipe(
    ofType(REQUEST_PERISCOPE_DASHBOARD),
    RxOp.mergeMap(() =>
      requestEpic({
        requestMethod: getPeriscopeDashboard,
        requestArgs: {
          token: S.fromMaybe("")(getAuthToken()),
          agencies: S.pipe([S.fromMaybe([]), S.map(S.prop("name"))])(
            getCurrentUserAgencies(state$.value)
          ),
          client: S.pipe([S.map(S.prop("brand")), S.fromMaybe("")])(
            getCurrentUserClient(state$.value)
          ),
        },
        onSuccess: (res) =>
          Rx.of(getPeriscopeDashboardSucceeded({ url: res.value.url })),
        onFailure: (err) => Rx.of(getPeriscopeDashboardFailed({ error: err.value })),
      })
    ),
    RxOp.catchError((err) => getPeriscopeDashboardFailed({ error: err.message }))
  );

export default requestPeriscopeDashboardEpic;
